import { render, staticRenderFns } from "./MiElementPanelTabbed.vue?vue&type=template&id=bcabead4&"
import script from "@/components/MiElementPanelTabbed/MiElementPanelTabbed.ts?vue&type=script&lang=ts&"
export * from "@/components/MiElementPanelTabbed/MiElementPanelTabbed.ts?vue&type=script&lang=ts&"
import style0 from "@/components/MiElementPanelTabbed/mi-element-panel-tabbed.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
